module.exports = __webpack_public_path__ + "static/media/acr_centroid_diamond_merge.e2941f27.svg";